/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { useMutation } from '@tanstack/react-query'
import type { UseMutationOptions } from '@tanstack/react-query'
import type { AxiosError, AxiosRequestConfig } from 'axios'
import { adDesignStore } from '../../axios/adDesignStore'
import type {
	AdDesignStoreError,
	AdDesignStorePathParams,
	AdDesignStoreRequest,
	AdDesignStoreResponse,
} from '../../types/AdDesignStore'

export const adDesignStoreMutationKey = () => [{ url: '/organisations/:organisation/ad-designs' }] as const

export type AdDesignStoreMutationKey = ReturnType<typeof adDesignStoreMutationKey>

export type AdDesignStoreVariables = {
	organisation: AdDesignStorePathParams['organisation']
	data: AdDesignStoreRequest
}

/** @see backend/nexus/modules/Organisation/Http/Controllers/AdDesignController.php AdDesignController::store */
export function useAdDesignStore<TContext = unknown>(
	options?: UseMutationOptions<
		AdDesignStoreResponse,
		AxiosError<AdDesignStoreError>,
		AdDesignStoreVariables,
		TContext
	>,
	config?: AxiosRequestConfig,
) {
	return useMutation({
		mutationKey: adDesignStoreMutationKey(),
		mutationFn: ({ organisation, data }: AdDesignStoreVariables) =>
			adDesignStore(organisation, data, config).then(res => res.data),
		...options,
	})
}
